import api from '~/services/api';
import { AjusteCreatePayload, ApiResponse } from '../types';

const createAjuste = async (
  payload: AjusteCreatePayload,
): Promise<ApiResponse> => {
  const { data } = await api.post<ApiResponse>('/ajuste', payload);

  return data;
};

const cancelAjuste = async (
  codSeqAjusteEstoque: number,
): Promise<ApiResponse> => {
  const { data } = await api.delete<ApiResponse>(
    `/ajuste/${codSeqAjusteEstoque}`,
  );

  return data;
};

export const ajusteDeEstoqueServices = {
  createAjuste,
  cancelAjuste,
};
